import { Button, Divider, Grid, IconButton, Paper, Typography } from "@mui/material";
import React, { useState } from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import { useNavigate } from "react-router-dom";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import { RoundOff } from "./RoundOff";
import { Remark } from "./Remark";
import { ChangeRate } from "./ChangeRate";
import { TaxExemption } from "./TaxExemption";

export const ReceiptModification: React.FC<any> = React.memo((props) => {
    const [selectedIndex, setSelectedIndex] = useState(0); // State for selected index
    const navigate = useNavigate()
    const handleClick = (path:string) =>{
        navigate(path)
       }

       const items = [
         "Round Off",
         "Remark",
         "Change Rate/Name",
         "Tax Exemption"
       ];

       const renderContent = () => {
        switch (selectedIndex) {
          case 0:
            return <RoundOff />; // Render RoundOff component
          case 1:
            return <Remark/>;
          case 2:
            return <ChangeRate/>;
          case 3:
            return <TaxExemption/>;
          default:
            return null;
        }
      };
    
       const columns: IColumns[] = [
        {
            header: "Description",
            fieldName: "workLocationName",
            tooltip: true,
        },
        {
            header: "Rate",
            fieldName: "address",
            tooltip: true,
        },
        {
            header: "Quantity",
            fieldName: "address",
            tooltip: true,
        },
        {
            header: "Discount",
            fieldName: "address",
            tooltip: true,
        },
        {
            header: "Tax 1",
            fieldName: "address",
            tooltip: true,
        },
        {
            header: "Tax 2",
            fieldName: "address",
            tooltip: true,
        },
        {
            header: "Tax 3",
            fieldName: "address",
            tooltip: true,
        },
        {
            header: "Total Tax",
            fieldName: "address",
            tooltip: true,
        },
        {
            header: "Total",
            fieldName: "address",
            tooltip: true,
        },
    ];
    const data = [
        { label: 'Amount', value: '0.00' },
        { label: 'Item Discount', value: '0.00' },
        { label: 'Tax', value: '0.00' },
        { label: 'Bill Dis.', value: '0' },
        { label: 'Round Off', value: '0' },
        { label: 'Total', value: '0' },
        { label: 'Amount Paid', value: '0' },
        { label: 'Amount Post', value: '0' },
      ];
     
  return (
<Grid container direction="column"  >
          <Grid item sx={{display:"flex", justifyContent:"space-between", alignItems: 'center', padding: '16px' }}>
        <Typography variant="h6" color={"green"}>Receipt Modification</Typography>
        <IconButton>
          <WSIcons.CloseIcon
            sx={{ backgroundColor: "red", color: "white" }}
            onClick={() => handleClick("/takeaway")}
          />
        </IconButton>
      </Grid>
      <Grid item>
      <WSDataGrid
                    id="modificationGrid"
                    title=""
                    columns={columns}
                />
        </Grid>
        <Grid container spacing={4} padding={2} mt={2}>
  {/* Left Menu */}
  <Grid item xs={12} sm={2} >
    <Paper
      sx={{
        padding: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        alignItems: 'center',
      }}
    >
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <Typography
            onClick={() => setSelectedIndex(index)} // Update selected index on click
            sx={{
              display: "flex",
              backgroundColor: selectedIndex === index ? 'green' : 'transparent', // Highlight selected item
              color: selectedIndex === index ? 'white' : 'black',
              width: '100%',
              cursor: 'pointer',
              justifyContent: "center",
            }}
          >
            {item}
          </Typography>
          <Divider sx={{ width: '100%' }} />
        </React.Fragment>
      ))}
    </Paper>
  </Grid>

  {/* Content Area */}
  <Grid item xs={12} sm={6} sx={{ mt: 2,border:"1px solid grey"}}>
    {/* Render content based on selected item */}
    {renderContent()}
  </Grid>

  {/* Optional Grid for other content */}
  <Grid item xs={12} sm={4} sx={{ mt: 2,border:"1px solid grey"}}>
      <Grid container spacing={1}>
        {data.map((item, index) => (
          <React.Fragment key={index}>
            <Grid item xs={6}>
              <Typography>{item.label}</Typography>
            </Grid>
            <Grid item xs={6} sx={{ textAlign: 'right' }}>
              <Typography>{item.value}</Typography>
            </Grid>
          </React.Fragment>
        ))}
    </Grid>  </Grid>
</Grid>
     {/* Footer Section */}
     <Grid item
      sx={{
        backgroundColor: "#333", 
        padding: "1rem",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Grid container spacing={2} alignItems="center" gap={3}>
        <Grid item>
          <WSIcons.GTranslateIcon sx={{ color: "white" }} />
        </Grid>
        
      </Grid>

        <Button
          variant="contained"
          sx={{
            backgroundColor: "green",
            "&:hover": {
              backgroundColor: "#388e3c",
            },
          }}
        >
          Finish
        </Button>
      </Grid>
    </Grid>
  );
});
